import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Modal from '../../../../Modal';


class FundingShareManageModal extends Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    hasPermission: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    isCustom: PropTypes.bool.isRequired,
    companyShares: PropTypes.array,
    investorId: PropTypes.number.isRequired,
    investmentId: PropTypes.number.isRequired,
    createFundingShare: PropTypes.func.isRequired,
    deleteFundingShares: PropTypes.func.isRequired,
  }

  static defaultProps = {
    companyShares: null,
  }

  constructor(props) {
    super(props);

    this.initialState = {
      custom: props.isCustom,
    };

    this.state = this.initialState;
  }

  onSelect = custom => this.setState({ custom });

  checkPermission = () => {
    const { hasPermission } = this.props;
    const { custom } = this.state;

    return (custom || hasPermission);
  }

  handleCloseModal = async () => {
    const { closeModal } = this.props;

    await closeModal();
    setTimeout(() => this.setState(this.initialState), 500);
  }

  submit = async () => {
    const {
      closeModal,
      investorId,
      investmentId,
      createFundingShare,
      deleteFundingShares,
    } = this.props;

    if (!this.checkPermission()) return;

    const { custom } = this.state;
    const today = new Date();
    const share = {
      date_of_investment: `${today.getDate()}-${today.getMonth() + 1}-${today.getFullYear()}`,
    };

    if (custom) {
      await createFundingShare(investorId, investmentId, { funding_share: share });
    } else {
      await deleteFundingShares(investorId, investmentId);
    }
    closeModal();
  }

  renderCompanyShares = () => {
    const { companyShares, hasPermission } = this.props;

    if (!hasPermission) {
      return (
        <div>
          <span className="text-light-gray h6 lh-1 mb1">
            You don&#39;t have access to the company shares.
          </span>
        </div>
      );
    }

    return (
      <div>
        <div className="text-light-gray h6 lh-1 mb2">
          * Data provided by the company will be shown. This also overwrites all the custom data you have previously entered.
        </div>
        <div className="flex py1 text-light-gray border-top border-bottom border-lighter-gray">
          <div className="col-4">% Shares (#)</div>
          <div className="col-4">Share type</div>
          <div className="col-4">Shares value</div>
        </div>
        {companyShares.map(s => (
          <div key={`share_${Math.random()}`} className="flex py1 border-bottom border-lighter-gray">
            <div className="col-4">{`${Math.round(s.ownership * 100) / 100}% (${s.readable_no_of_shares})`}</div>
            <div className="col-4">{s.share_type}</div>
            <div className="col-4">{s.readable_amount}</div>
          </div>
        ))}
      </div>
    );
  }

  render() {
    const { show } = this.props;
    const { custom } = this.state;

    return (
      <Modal
        show={show}
        onClickOutside={this.handleCloseModal}
      >
        <div className="flex flex-justify-between items-center semi-bold p2 border-bottom border-lighter-gray">
          <div className="h3">Manage your investments</div>
          <i className="fa fa-close h5 cursor-pointer" onClick={this.handleCloseModal} />
        </div>

        <div className="fw400 px3 py2 overflow-y-auto" style={{ maxHeight: '65vh' }}>
          <div className="flex flex-justify-end">
            <div
              className={`h6 px1 py05rem cursor-pointer ${custom ? 'text-white bg-blue' : 'text-light-gray'}`}
              onClick={() => this.onSelect(true)}
            >
              Custom
            </div>
            <div
              className={`h6 px1 py05rem cursor-pointer ${custom ? 'text-light-gray' : 'text-white bg-green'}`}
              onClick={() => this.onSelect(false)}
            >
              Company
            </div>
          </div>

          <div className={`col-12 border p2 ${custom ? 'border-blue' : 'border-green'}`}>
            {custom ?
              <div>
                <span className="text-light-gray h6 lh-1 mb1">
                  * Data entered by you will be shown. You can always switch back to data provided by the company.
                </span>
              </div>
              :
              this.renderCompanyShares()
            }
          </div>
        </div>

        <div className="flex flex-justify-end items-center p2 border-top border-lighter-gray">
          <div
            className="h5 text-blue mr2 cursor-pointer"
            onClick={this.handleCloseModal}
          >
            Cancel
          </div>
          <div
            className={`h5 p1 px2 rounded ${this.checkPermission() ? 'bg-blue text-white cursor-pointer' : 'bg-light-gray text-white cursor-disabled'}`}
            onClick={this.submit}
          >
            Save
          </div>
        </div>
      </Modal>
    );
  }
}

export default FundingShareManageModal;
